import useMediaQuery from './useMediaQuery';

// export types
export type { Query } from './types';

// export hooks
export { useMediaQuery };
export default useMediaQuery;
